import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-chat-bot-form',
  templateUrl: './chat-bot-form.component.html',
  styleUrls: ['./chat-bot-form.component.css'],
})
export class ChatBotFormComponent {
  url: string = '';
  id!: string;
  form!: FormGroup;

  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-message',
      bgClass: 'bg-white',
      desc: 'WpBot',
      route: '/hub',
    },
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-message',
      bgClass: 'bg-white',
      desc: 'BookingBot ',
      route: '/hub/chatbot',
    },
  ];

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService
  ) {
    this.form = this.fb.group({
      client: ['anamaria@email.com', [Validators.required]],
      platform: ['Mobile', [Validators.required]],
      city: ['Bogotá', [Validators.required]],
      talkTime: ['3m 12s', [Validators.required]],
      bookingStep: ['Múltiples drop-offs', [Validators.required]],
      summary: [
        'El cliente expresó confusión al gestionar varios drop-offs en una misma orden.Preguntó si debía crear varias órdenes. La IA guió paso a paso con éxito.',
        [Validators.required],
      ],
      conclusions: [
        `- Finalizó : X\n - Nivel de confusión detectad: Media\n  - Paso con fricción: Drop-off\n - Sugerencia IA: Mostrar tooltip adicional en paso 2 del booking`,
        [Validators.required],
      ],
      notes: ['Este es el 12º usuario en 10 días que se detiene más de 1 min en el paso de múltiples entregas. Revisar UX de ese flujo', [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];

      if (this.id) {
        //this.getData();
      }
    });
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    if (this.id) {
      this.updateData();
    } else {
      this.createData();
    }
  }

  getData(): void {
    this.dataService.getData(`${this.url}/${this.id}`).subscribe((response) => {
      this.form.patchValue({
        description: response.description,
        value: response.value,
        frequency: response.frequency,
        dueDate: response.dueDate,
      });
    });
  }

  createData(): void {
    const formData = {
      ...this.form.value,
    };

    this.dataService
      .postData(`${this.url}/add`, formData)
      .subscribe((response) => {
        console.log('response add', response);
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.router.navigateByUrl('/numbers/accounting/external');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  updateData(): void {
    const formData = {
      ...this.form.value,
    };

    //console.log('formData up',formData)
    this.dataService
      .putData(`${this.url}/edit/${this.id}`, formData)
      .subscribe((response) => {
        console.log('response up', response);
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.router.navigateByUrl('/numbers/accounting/external');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }
}
